import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BadgeModule } from '../common/badge/badge.module';
import { BoxModule } from '../common/box/box.module';
import { HeadingModule } from '../common/heading/heading.module';
import { IconModule } from '../common/icon/icon.module';
import { NewItemButtonComponent } from './new-item-button.component';

@NgModule({
  imports: [CommonModule, BoxModule, IconModule, HeadingModule, BadgeModule],
  declarations: [NewItemButtonComponent],
  exports: [NewItemButtonComponent],
})
export class RtNewItemButtonModule {}
export { NewItemButtonComponent } from './new-item-button.component';
